import React, { useState, useEffect } from "react";
import "./EtudeDetailsPage.css";
import MainTabContent from "../../components/Study/StudyNotebook/MainTabContent/MainTabContent";
import FormsTabContent from "../../components/Study/StudyNotebook/FormsTabContent/FormsTabContent";
import FormsDetailsContent from "../../components/document/FormsDetailsContent/FormsDetailsContent";
import InvestigatorsTabContent from "../../components/Study/StudyNotebook/InvesTabContent/InvestigatorsTabContent";
import MembersDetails from "../../components/study_member/MembersDetails/MembersDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faUsers,
  faClipboardList,
} from "@fortawesome/free-solid-svg-icons";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useParams, useLocation } from "react-router-dom";

const EtudeDetailsPage = () => {
  const location = useLocation();
  const { studyId } = useParams();

  const defaultTab = location.state?.tab || "main";
  const [activeTab, setActiveTab] = useState(defaultTab);

  // --- Form section states ---
  const [formsView, setFormsView] = useState("list");
  const [selectedFormId, setSelectedFormId] = useState(null);

  // --- Investigator section states ---
  const [investigatorsView, setInvestigatorsView] = useState("Invlist");
  const [selectedInvestigatorId, setSelectedInvestigatorId] = useState(null);

  useEffect(() => {
    if (location.state?.tab) {
      setActiveTab(location.state.tab);
    }
  }, [location.state?.tab]);

  return (
    <main className="content-details flex-grow-1 pt-4">
      {/* ----------- TABS HEADER ----------- */}
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "main" ? "active" : ""}`}
            onClick={() => setActiveTab("main")}
          >
            <div className="tab-layout">
              <FontAwesomeIcon icon={faBook} className="tab-icon" />
              <div className="tab-text">
                <div className="tab-title">Etude</div>
                <div className="tab-subtitle">Détails principaux</div>
              </div>
            </div>
          </button>
        </li>

        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "forms" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("forms");
              setFormsView("list");
            }}
          >
            <div className="tab-layout">
              <FontAwesomeIcon icon={faClipboardList} className="tab-icon" />
              <div className="tab-text">
                <div className="tab-title">Etude</div>
                <div className="tab-subtitle">Formulaires</div>
              </div>
            </div>
          </button>
        </li>

        <li className="nav-item">
          <button
            className={`nav-link ${
              activeTab === "investigators" ? "active" : ""
            }`}
            onClick={() => setActiveTab("investigators")}
          >
            <div className="tab-layout">
              <FontAwesomeIcon icon={faUsers} className="tab-icon" />
              <div className="tab-text">
                <div className="tab-title">Etude</div>
                <div className="tab-subtitle">Investigateurs</div>
              </div>
            </div>
          </button>
        </li>
      </ul>

      {/* ----------- TABS CONTENT ----------- */}
      <div className="tab-content-study-details p-3">
        {[
          activeTab === "main" && (
            <MainTabContent key="main-tab" studyId={studyId} />
          ),

          activeTab === "forms" &&
            (formsView === "list" ? (
              <FormsTabContent
                key="forms-list"
                onShowDetails={(formId) => {
                  setSelectedFormId(formId);
                  setFormsView("details");
                }}
              />
            ) : (
              <FormsDetailsContent
                key="forms-details"
                formId={selectedFormId}
                onBack={() => setFormsView("list")}
              />
            )),

          activeTab === "investigators" &&
            (investigatorsView === "Invlist" ? (
              <InvestigatorsTabContent
                key="investigators-list"
                onShowInvesDetails={(id) => {
                  setSelectedInvestigatorId(id);
                  setInvestigatorsView("Inv");
                }}
              />
            ) : (
              <MembersDetails
                key="investigator-details"
                studyId={studyId}
                investigatorId={selectedInvestigatorId}
                type="investigator"
                onBack={() => setInvestigatorsView("Invlist")}
              />
            )),
        ]}
      </div>
    </main>
  );
};

export default EtudeDetailsPage;
